export default __webpack_public_path__ + "static/media/helmet2.535560a6.svg";